import {
   useColorModeValue,
   useDisclosure,
   useColorMode,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   Flex,
   VStack,
   Skeleton,
   Box,
   ModalFooter,
   Text,
   Image,
   HStack,
   Icon,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CiMenuKebab } from 'react-icons/ci';
import { getWpQrCode } from '../../../../redux/actions/settings';
import { useUser } from 'contexts';
import ElevenZa from '../../../../assets/img/11za_logo.svg';

const QrCodeModal = ({ isOpen: externalIsOpen = false, onClose: externalOnClose = null }) => {
   const { user } = useUser();
   const dispatch = useDispatch();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const qrcode = useSelector((state) => state.settings.wpQrCode);
   const [isLoading, setIsLoading] = useState(true);

   const internalDisclosure = useDisclosure();
   const { isOpen: internalIsOpen, onOpen: internalOnOpen, onClose: internalOnClose } = internalDisclosure;

   const isControlled = externalOnClose !== null;
   const isOpen = isControlled ? externalIsOpen : internalIsOpen;
   const onClose = isControlled ? externalOnClose : internalOnClose;

   const headingColor = useColorModeValue('gray.800', 'white');
   const modalBgColor = useColorModeValue('white', 'gray.800');
   const qrBoxBg = useColorModeValue('white', 'white');
   const qrBoxBorder = useColorModeValue('gray.200', 'gray.600');
   const instructionBg = useColorModeValue('gray.50', 'gray.700');

   useEffect(() => {
      if (isOpen) {
         setIsLoading(true);
         dispatch(getWpQrCode({ companyId: user?.loginhistory?.companyId }));
      }
   }, [isOpen, user?.loginhistory?.companyId, dispatch]);

   useEffect(() => {
      if (qrcode?.qrCodeUrl) {
         setIsLoading(false);
      }
   }, [qrcode]);

   return (
      <Modal isOpen={isOpen} onClose={onClose} size={{ base: 'sm', md: 'md' }} isCentered>
         <ModalOverlay />
         <ModalContent mx={{ base: 4, sm: 0 }} bg={modalBgColor}>
            <ModalHeader
               py={4}
               fontSize="lg"
               color={headingColor}
               borderBottom="1px solid"
               borderColor={isDark ? 'gray.700' : 'gray.200'}>
               Connect WhatsApp
            </ModalHeader>
            <ModalCloseButton />

            <ModalBody py={6}>
               {isLoading ? (
                  <Flex w="full" justifyContent="center" alignItems="center" minH="300px">
                     <VStack spacing={4}>
                        <Skeleton
                           width="220px"
                           height="220px"
                           borderRadius="md"
                           startColor={isDark ? 'gray.600' : 'gray.200'}
                           endColor={isDark ? 'gray.700' : 'gray.300'}
                        />
                        <Skeleton
                           height="20px"
                           width="150px"
                           startColor={isDark ? 'gray.600' : 'gray.200'}
                           endColor={isDark ? 'gray.700' : 'gray.300'}
                        />
                     </VStack>
                  </Flex>
               ) : (
                  <VStack spacing={5} w="full">
                     {/* 11za Logo */}
                     <Image src={ElevenZa} alt="11za" width="100px" objectFit="contain" />

                     {/* QR Code */}
                     <Box
                        bg={qrBoxBg}
                        p={1}
                        border="1px solid"
                        borderColor={qrBoxBorder}
                        borderRadius="md"
                        boxShadow="sm">
                        {qrcode?.qrCodeUrl && (
                           <Box
                              as="img"
                              src={`${qrcode.qrCodeUrl}?t=${Date.now()}`}
                              alt="QR Code"
                              width="200px"
                              height="200px"
                              objectFit="contain"
                              style={{ display: 'block' }}
                           />
                        )}
                     </Box>

                     <Text fontSize="sm" fontWeight="medium" color={isDark ? 'gray.300' : 'gray.700'}>
                        Scan with your phone to connect
                     </Text>

                     {/* Instructions */}
                     <Box w="full" bg={instructionBg} p={4} borderRadius="md">
                        <Text fontSize="xs" fontWeight="semibold" mb={2} color={isDark ? 'gray.300' : 'gray.700'}>
                           Quick Steps:
                        </Text>
                        <VStack align="start" spacing={1.5} fontSize="xs" color={isDark ? 'gray.400' : 'gray.600'}>
                           <Text>1. Open WhatsApp on your phone</Text>
                           <HStack spacing={1}>
                              <Text>2. Tap</Text>
                              <Icon as={CiMenuKebab} />
                              <Text>on Right Corner or Settings</Text>
                           </HStack>
                           <Text>3. Select "Linked Devices"</Text>
                           <Text>4. Tap "+ Link a Device"</Text>
                           <Text>5. Scan this QR code</Text>
                        </VStack>
                     </Box>
                  </VStack>
               )}
            </ModalBody>

            <ModalFooter
               py={3}
               borderTop="1px solid"
               borderColor={isDark ? 'gray.700' : 'gray.200'}
               justifyContent="center">
               <Text fontSize="xs" className="flex gap-1" color={isDark ? 'gray.500' : 'gray.500'}>
                  Powered by <Image src={ElevenZa} alt="11za" width="50px" objectFit="contain" />
               </Text>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );
};

export default QrCodeModal;
